<template>
    <button-group-attribute v-if="isButtonGroup() && !isDeleted() && !isHidden()"
                            :date-format="dateFormat"
                            :time-format="timeFormat"
                            :attributes="attributes"
                            :attribute="attribute"
                            :clone="clone"
                            :currency="currency"
                            :unit="unit"
                            :additional-time-text-data="Additional_Time_Text"
                            v-model="attribute.selected">
    </button-group-attribute>

    <!-- Dropdown Field Start -->
    <dropdown-attribute v-else-if="isDropdown() && !isDeleted() && !isHidden()"
                        :attributes="attributes"
                        :attribute="attribute"
                        :clone="clone"
                        :currency="currency"
                        :unit="unit"
                        v-model="attribute.selected"
                        :additional-time-text-data="Additional_Time_Text">
    </dropdown-attribute>
    <!-- Dropdown Field End -->

    <!-- Date Field Start -->
    <date-attribute v-else-if="isDate() && !isDeleted() && !isHidden()"
                    :date-format="dateFormat"
                    :attribute="attribute"
                    :clone="clone"
                    :currency="currency"
                    :unit="unit"
                    v-model="attribute.value">
    </date-attribute>
    <!-- Date Field End -->

    <!-- Time Field Start -->
    <time-attribute v-else-if="isTime() && !isDeleted() && !isHidden()"
                    :time-format="timeFormat"
                    :attribute="attribute"
                    :clone="clone"
                    :currency="currency"
                    :unit="unit"
                    v-model="attribute.value">
    </time-attribute>
    <!-- Time Field End -->

    <!-- Checkbox Field Start -->
    <checkbox-attribute v-else-if="isCheckbox() && !isDeleted() && !isHidden()"
                        :date-format="dateFormat"
                        :time-format="timeFormat"
                        :attributes="attributes"
                        :attribute="attribute"
                        :clone="clone"
                        :additional-time-text-data="Additional_Time_Text"
                        :currency="currency"
                        :unit="unit" :item-id="itemId"
                        v-model="attribute.selected">
    </checkbox-attribute>
    <!-- Checkbox Field End -->

    <!-- Toggle Field Start -->
    <toggle-attribute v-else-if="isToggle() && !isDeleted() && !isHidden()"
                      :date-format="dateFormat"
                      :time-format="timeFormat"
                      :attributes="attributes"
                      :attribute="attribute"
                      :clone="clone"
                      :additional-time-text-data="Additional_Time_Text"
                      :currency="currency"
                      :unit="unit"
                      v-model="attribute.service_attribute_value">
    </toggle-attribute>
    <!-- Toggle Field End -->

    <!-- Toggle Field Start -->
    <longtext-attribute v-else-if="(isLongText() && !isDeleted() && !isHidden()) || isMandatory()"
                        :clone="clone"
                        :currency="currency"
                        :unit="unit"
                        :attribute="attribute"
                        v-model="attribute">
    </longtext-attribute>
    <!-- Toggle Field End -->

    <!-- Signature Field Start -->
    <signature-attribute v-else-if="isSignature() && !isDeleted() && !isHidden()"
                         :attribute="attribute"
                         :clone="clone"
                         :currency="currency"
                         :unit="unit"
                         :item-id="itemId"
                         v-model="attribute.value">
    </signature-attribute>
    <!-- Signature Field Start -->

    <!-- Plus Field Start -->
    <plus-minus-attribute v-else-if="isPlusMinusButtonsInput() && !isDeleted() && !isHidden()"
                          :attribute="attribute"
                          :clone="clone"
                          :currency="currency"
                          :additional-time-text-data="Additional_Time_Text"
                          :unit="unit"
                          v-model="attribute.value">
    </plus-minus-attribute>
    <!-- Signature Field Start -->

    <!-- Radio Button Field Start -->
    <radio-button-attribute v-else-if="isRadioButton() && !isDeleted() && !isHidden()"
                            :date-format="dateFormat"
                            :time-format="timeFormat"
                            :attributes="attributes"
                            :additional-time-text-data="Additional_Time_Text"
                            :attribute="attribute"
                            :clone="clone"
                            :currency="currency"
                            :unit="unit"
                            v-model="attribute.selected">

    </radio-button-attribute>
    <!-- Radio Button Field End -->

    <!-- Radio Button Field Start -->
    <list-attribute v-else-if="isList() && !isDeleted() && !isHidden()"
                    :date-format="dateFormat"
                    :time-format="timeFormat"
                    :attributes="attributes"
                    :additional-time-text-data="Additional_Time_Text"
                    :attribute="attribute"
                    :clone="clone"
                    :currency="currency"
                    :unit="unit"
                    v-model="attribute.selected"></list-attribute>
    <!-- Radio Button Field End -->

    <!-- Text Field Start -->
    <text-attribute v-else-if="isNormalTextBox() && !isDeleted() && !isHidden()"
                    :attribute="attribute"
                    :clone="clone"
                    :currency="currency"
                    :additional-time-text-data="Additional_Time_Text"
                    :unit="unit"
                    v-model="attribute.value">
    </text-attribute>
    <!-- Text Field End -->
</template>

<script>

import attributes from "@/modules/Services/components/attributes/Attributes.vue";

export default {
    name: "attribute",
    props: {
        attributes: {
            type: Array,
            default() {
                return []
            }
        },
        dateFormat: {
            required: true
        },
        timeFormat: {
            required: true
        },
        clone: {
            required: true
        },
        currency: {
            required: true
        },
        unit: {
            required: true
        },
        value: {
            required: true
        },
        itemId: {},
    },
    data() {
        return {
            constants: {
                ENUM: 'Enum',
                DROPDOWN: 'dropdown',
                DATE: 'date',
                TIME: 'time',
                CHECKBOX: 'set',
                LONGTEXT: 'long_text',
                TEXTINPUT: 'text_input',
                TOGGLE: 'checkbox',
                SIGNATURE: 'signature',
                LIST: 'multiselect'
            },
            attribute: this.value
        }
    },
    methods: {
        isPlusMinusButtonsInput() {
            return this.attribute.attribute_type == this.constants['TEXTINPUT'] && this.attribute.is_new == 1;
        },
        isNormalTextBox() {
            return this.attribute.attribute_type == this.constants['TEXTINPUT'] && this.attribute.is_new == 0;
        },
        isRadioButton() {
            return this.attribute.attribute_type == this.constants['ENUM'] && this.attribute.is_new == 0;
        },
        isButtonGroup() {
            return this.attribute.attribute_type == this.constants['ENUM'] && this.attribute.is_new == 1;
        },
        isList() {
            return this.attribute.attribute_type == this.constants['LIST']
        },
        isDropdown() {
            return this.attribute.attribute_type == this.constants['DROPDOWN']
        },
        isDate() {
            return this.attribute.attribute_type == this.constants['DATE']
        },
        isTime() {
            return this.attribute.attribute_type == this.constants['TIME']
        },
        isCheckbox() {
            return this.attribute.attribute_type == this.constants['CHECKBOX']
        },
        isToggle() {
            return this.attribute.attribute_type == this.constants['TOGGLE']
        },
        isLongText() {
            return this.attribute.attribute_type == this.constants['LONGTEXT']
        },
        isSignature() {
            return this.attribute.attribute_type == this.constants['SIGNATURE']
        },
        isDeleted() {
            return this.attribute.is_deleted;
        },
        isMandatory() {
            return this.attribute.attribute_name == 'Description' || this.attribute.attribute_name == 'Service Manual'
        },
        isHidden() {
            return this.attribute.is_hidden;
        },
        Additional_Time_Text(val) {
            if ( val ){
                /** floor to get hours  **/
                var hours=Math.floor(val);
                /** if hours is empty not show hours   **/
                if (hours == 0){hours ='';}
                /** add s to  hours **/
                else if(hours > 1 ){hours =hours+ ' Hrs';}
                else{hours =hours+' Hr';}
                /** round to get minutes     **/
                var minutes = Math.round( val * 60) % 60 ;
                if (minutes == 0){minutes ='';}
                /** add  and to  Minutes **/
                else if(minutes > 1){
                    if (hours ==''){
                        minutes =minutes+ ' Min';
                    }
                    else{minutes ='& '+minutes+ ' Min';}
                }
                else{ minutes =minutes+' Min';   }
                return '+'+hours+' '+minutes ;
            }
        },

    },
    watch: {
        attribute: {
            handler(attribute) {
              console.log(this.value)
                this.$emit('input', attribute)
            },
            deep: true,
        }
    }
}
</script>

<style scoped>

</style>